import type { AnyExtension, JSONContent } from '@tiptap/core'

import StarterKit from '@tiptap/starter-kit'

import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import ListItem from '@tiptap/extension-list-item'
import { TextStyle } from '@tiptap/extension-text-style'
import TaskList from '@tiptap/extension-task-list'

import { CustomTaskItem } from './taskitem/TaskItemExtension'
import { ImageNode } from './image/ImageNode'
import { FileNode } from './file/FileNode'
import { VariableNode } from './variables/VariableNode'
import { MentionNode } from './mentions/MentionNode'
import { CustomShortcutsExtension } from './custom/custom-shortcuts'

export const TIPTAP_CLASSES = {
  BASE: 'tiptap ProseMirror',
  STATIC: 'tiptap-static',
  LIVE: 'tiptap-live',
} as const

/**
 * Cached collection of Tiptap extensions for CellContent editor.
 */
export const TIPTAP_EXTENSIONS = [
  Color.configure({ types: [TextStyle.name, ListItem.name] }),
  TextStyle,
  StarterKit,
  Highlight.configure({
    multicolor: true,
    HTMLAttributes: {
      class: 'px-0.5 rounded-xs box-decoration-clone',
    },
  }),
  CustomTaskItem,
  TaskList,
  // Custom nodes
  ImageNode,
  FileNode,
  VariableNode,
  MentionNode,
  // Custom features
  CustomShortcutsExtension,
] as const satisfies AnyExtension[]

export interface EmptyParagraphBlock extends JSONContent {
  type: 'paragraph'
}

export const EMPTY_PARAGRAPH_JSON = {
  type: 'paragraph',
} as const satisfies EmptyParagraphBlock

export const EMPTY_DOC_JSON = {
  type: 'doc',
  content: [EMPTY_PARAGRAPH_JSON],
} as const satisfies JSONContent

export const EMPTY_PARAGRAPH_HTML = '<p></p>' as const
